import React from "react";
import { EmailSection } from "./EmailSection";
import styles from "./SidePanel.module.scss";

// The send step's side panel: just the email options section (the same one
// the details step used to embed), while the email preview fills the pane.
export const SendEmailPanel: React.FC = () => (
    <div className={styles.panelContent}>
        <EmailSection />
    </div>
);
